import { render } from 'preact';
import { Provider } from 'react-redux';
import { App } from './app.tsx';
import { store } from './store/index.ts';
import { applyGateRedirect } from './lib/inflow.ts';
import { watchAppHeight } from './lib/viewport.ts';
import './styles/index.scss';

/*
  ★ **무엇보다 먼저 처리한다.** (2026-09-17)

  `/f/dongguk/mission` 같은 유입 주소를 `/mission` 으로 바꿔 놓고 앱을 띄운다.
  앱이 그려진 뒤에 바꾸려 하면 늦다 — 라우터가 먼저 `/f/...` 를 읽고 '없는 페이지' 를
  그려 버리고, 그 시점에는 preact-router 의 `route()` 도 듣지 않는다(inflow.ts 주석 참고).
*/
applyGateRedirect();

// 첫 화면을 그리기 전에 실제 보이는 높이부터 잡는다(인앱 브라우저 스크롤).
watchAppHeight();

const container = document.getElementById('app');
if (!container) throw new Error('#app 엘리먼트를 찾을 수 없습니다.');

render(
  <Provider store={store}>
    <App />
  </Provider>,
  container
);
